<template>
  <div class="container">
    <app-data-view-header
      :has-create="hasCreate"
      :search.sync="search"
      :headers="headers"
      :order-by.sync="orderBy"
      :sort="sortSettings"
      :has-view-as="false"
      :has-order-by="false"
      @click:create="addUser()"
    >
    </app-data-view-header>
    <app-data-viewer
      grid-has-edit
      :loading="loadingList"
      :items="filteredItems"
      :headers="headers"
      :order-by.sync="orderBy"
      view-by="list"
      @click:grid-edit="editUser($event)"
      @click:list-row="editUser($event)"
    >
      <template v-slot:list.item.fullname="{ item }">
        {{ item.firstName + ' ' + item.lastName }}
      </template>
      <template v-slot:list.item.roles="{ item }">
        {{ item.roles.map(el => el.name).join(', ') }}
      </template>
      <template v-slot:list.item.actions="{ item }">
        <button class="button is-text is-icon" @click.stop="editUser(item)">
          <span class="icon icon-edit"></span>
        </button>
        <button
          class="button is-text is-icon"
          @click.stop="
            deleteDialog = true;
            selectedUser = item.userID;
          "
        >
          <span class="icon icon-delete"></span>
        </button>
      </template>
    </app-data-viewer>

    <confirm-dialog
      v-model="deleteDialog"
      @confirmed="deleteUser"
    ></confirm-dialog>
  </div>
</template>

<script>
import AppDataViewHeader from '@/components/AppDataViewHeader.vue';
import AppDataViewer from '@/components/AppDataViewer.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';

export default {
  name: 'UsersLists',
  components: {
    ConfirmDialog,
    AppDataViewHeader,
    AppDataViewer
  },
  data() {
    return {
      create: false,
      headers: [
        {
          text: "User's name",
          value: 'fullname',
          sortable: true,
          customSort: (a, b) => {
            if (a.__name < b.__name) {
              return -1;
            }
            if (a.__name > b.__name) {
              return 1;
            }
            return 0;
          }
        },
        {
          text: 'Email',
          value: 'email',
          sortable: true
        },
        {
          text: 'Roles',
          value: 'roles',
          width: '30%',
          sortable: false,
          customSort: (a, b) => {
            const aRoles = a.roles.map(el => el.name).join(', ');
            const bRoles = b.roles.map(el => el.name).join(', ');
            if (aRoles < bRoles) {
              return -1;
            }
            if (aRoles > bRoles) {
              return 1;
            }
            return 0;
          }
        },
        /*{
          text: 'Associated',
          value: 'associated',
          sortable: false
        },*/
        {
          text: '',
          value: 'actions',
          align: 'end',
          width: 180,
          permissions: [10003]
        }
      ],
      sortSettings: [],
      loadingList: true,
      deleteDialog: false,
      search: '',
      orderBy: {}
    };
  },
  computed: {
    filteredItems() {
      return this.$store.getters['users/search'](this.search);
    },
    hasCreate() {
      return this.hasPermission([10002]);
    }
  },
  mounted() {
    const args = {
      IncludeTrashed: false
    };

    if (!this.hasRole('ueg'))
      args.OrganizationID = this.$store.getters.userOrganization;

    this.axiosRequest('get', 'Users', args)
      .then(response => {
        this.$store.commit('users/set', response.data);
        this.loadingList = false;
      })
      .catch(error => {
        this.showErrorMessage(error);
      });
  },
  methods: {
    addUser() {
      this.$router.push({
        name: 'team.create'
      });
    },
    editUser(user) {
      this.$router.push({
        name: 'team.view',
        params: { id: user.userID }
      });
    },
    deleteUser() {
      this.axiosRequest('delete', `Users/${this.selectedUser}`)
        .then(() => {
          this.$store.commit('users/deleteById', this.selectedUser);
          this.deleteDialog = false;
        })
        .catch(error => {
          this.showErrorMessage(error);
        });
    }
  }
};
</script>

<style lang="scss"></style>
